import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { kindList } from "@/utils/constant";
import {
    Button,
    Table,
    Select,
    DatePicker,
    InputNumber,
    Pagination,
    Input,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class BetRecord extends React.Component {
    state = {
        loading: false, // 是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            vendor_id: undefined,
            member_uid: undefined,
            kpoker_uid: undefined,
            kind: undefined,
            bonus_type: undefined,
            date: [],
            reconciliationDate: [],
        },
        data: [], // 表格数据
        kindList: [
            // 游戏类型列表
            ...kindList,
            { value: 101, label: 'SQUID' },
            { value: 103, label: 'SUPER' },
            { value: 1000, label: 'ItemConsum' },
            { value: 1001, label: 'Bonus' },
            { value: 1002, label: 'Insurance' },
        ],
        bonusTypeList: [
            // bonus类型列表
            { value: 1, label: 'Bonus_Lucky' },
            { value: 2, label: 'Bonus_JackPot' },
            { value: 3, label: 'Bonus_HH' },
            { value: 4, label: 'Bonus_Hands' },
            { value: 5, label: 'Bonus_Quest' },
            { value: 6, label: 'Bonus_Pigy' },
        ],
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/kpoker_union/hand_detail_log", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    recon_begin_time:
                        this.state.queryParams.reconciliationDate[0] &&
                        this.state.queryParams.reconciliationDate[0].startOf("day").valueOf() / 1000,
                    recon_end_time:
                        this.state.queryParams.reconciliationDate[1] &&
                        this.state.queryParams.reconciliationDate[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                    reconciliationDate: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    vendor_id: undefined,
                    member_uid: undefined,
                    kpoker_uid: undefined,
                    kind: undefined,
                    bonus_type: undefined,
                    date: [],
                    reconciliationDate: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Input
                        maxLength={60}
                        allowClear
                        placeholder={this.props.language["proxyIdPlaceholder"]}
                        value={this.state.queryParams.vendor_id}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("vendor_id", e.target.value)
                        }
                    />
                    <Input
                        maxLength={60}
                        allowClear
                        placeholder={this.props.language["memberIdPlaceholder"]}
                        value={this.state.queryParams.member_uid}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("member_uid", e.target.value)
                        }
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["kpokerPlayerIdPlaceholder"]}
                        value={this.state.queryParams.kpoker_uid}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("kpoker_uid", value)
                        }
                    />
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["gameTypePlaceholder"]}
                        value={this.state.queryParams.kind}
                        onChange={(value) => this.handleSetQueryParamsData("kind", value)}
                    >
                        {this.state.kindList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    {this.state.queryParams.kind === 1001 &&
                        <Select Select
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            placeholder={this.props.language["bonusTypePlaceholder"]}
                            value={this.state.queryParams.bonus_type}
                            onChange={(value) => this.handleSetQueryParamsData("bonus_type", value)}
                        >
                            {this.state.bonusTypeList.map((item, index) => (
                                <Select.Option value={item.value} key={index}>
                                    {item.label}
                                </Select.Option>
                            ))}
                        </Select>
                    }
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <DatePicker.RangePicker
                        placeholder={[this.props.language["reconciliationStartDate"], this.props.language["reconciliationEndDate"]]}
                        value={this.state.queryParams.reconciliationDate}
                        onChange={(e) => this.handleSetQueryParamsData("reconciliationDate", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="tunix"
                        />
                        <Table.Column
                            align="center"
                            title="ID"
                            dataIndex="id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/proxy_detail/${item.vendor_id}`}>
                                    {item.vendor_id || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["memberId"]}
                            dataIndex="member_uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["kpokerPlayerId"]}
                            dataIndex="kpoker_uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["betId"]}
                            dataIndex="oid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchId"]}
                            dataIndex="mid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["handId"]}
                            dataIndex="hid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameNickname"]}
                            dataIndex="name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["betAmount"]}
                            dataIndex="bet_amt"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["profit"]}
                            dataIndex="win_amt"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["reconciliationDate"]}
                            dataIndex="recon_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex=""
                            render={(item) =>
                                item.kind === 1001 ?
                                    (
                                        this.state.bonusTypeList.find(
                                            (item2) => item2.value === item.bonus_type
                                        )
                                            ? this.state.bonusTypeList.find(
                                                (item2) => item2.value === item.bonus_type
                                            ).label
                                            : "Bonus"
                                    )
                                    :
                                    (
                                        this.state.kindList.find(
                                            (item2) => item2.value === item.kind
                                        )
                                            ? this.state.kindList.find(
                                                (item2) => item2.value === item.kind
                                            ).label
                                            : ""
                                    )
                            }
                        />
                    </Table>
                    <Pagination
                        className="pagination"
                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                    />
                </div>
            </div >
        );
    }
}
